import React from 'react'
import RadioButton from '@veneer/core/dist/scripts/radio_button'
import RadioGroup from '@veneer/core/dist/scripts/radio_group'

import classes from './SelectDomain.module.scss'

export function SelectDomain({
  pageData,
  retry,
  setSelectedOrganization,
  availableOrganizations,
  selectedOrganization
}) {
  const organizations = [
    ...availableOrganizations,
    {
      resourceId: 'new',
      accountName: pageData.new_organization
    }
  ]

  return (
    <RadioGroup
      name="radiobutton_default"
      className={classes.radioButtons}
      key="radio"
      onChange={(e) => setSelectedOrganization(e.target.value)}
    >
      {organizations.map((org) => {
        return (
          <div
            data-testid={`radio-button-${org.resourceId}`}
            key={org.resourceId}
          >
            <RadioButton
              checked={org.resourceId === selectedOrganization}
              className={classes.radioButton}
              key={org.resourceId}
              value={org.resourceId}
              label={org.accountName}
              disabled={retry}
            />
          </div>
        )
      })}
    </RadioGroup>
  )
}
